<!-- eslint-disable @typescript-eslint/no-explicit-any -->
<template>
  <i-local-search @click="openDropdown" class="MenuGlobalSearch-ui-icon" />
</template>
<script setup lang="ts">
  import { useGlobalSearchStore } from '@/store/GlobalSearch'

  const globalSearchStore = useGlobalSearchStore()
  const openDropdown = () => {
    globalSearchStore.openGlobalSearchDropDown()
  }
</script>
<style lang="scss" scoped>
  .MenuGlobalSearch-ui-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #4e4e4e;
    padding: 7px;
    cursor: pointer;
    transition: color 0.3s;
    &:hover {
      color: var(--accent-color2);
    }
  }
</style>
